export const getAssetsFile = (path: string) => {
  return require(`@/assets/${path}`);
};
